import {
    borrarDefaultDropDownOptions,
    defaultHeaderDropDown,
    freezeGenericMessage,
} from "../../../common/dataTables/utils";

const dataTableListaMaterialesElement = document.getElementById(
    "dataTableListaMateriales",
);

const columns = [
    {
        id: "materialHijo",
        name: "Material hijo",
        width: 180,
        editable: false,
        resizable: true,
        sortable: false,
        focusable: false,
        dropdown: true,
    },
    {
        id: "cantidadUtilizada",
        name: "Catidad utilizada",
        width: 150,
        editable: false,
        resizable: true,
        sortable: false,
        focusable: false,
        dropdown: false,
    },
    {
        id: "porcentaje_desperdicio",
        name: "% Desperdicio",
        width: 150,
        editable: false,
        resizable: true,
        sortable: false,
        focusable: false,
        dropdown: false,
    },
    {
        id: "porcentaje_merma",
        name: "% Merma",
        width: 150,
        editable: false,
        resizable: true,
        sortable: false,
        focusable: false,
        dropdown: false,
    },
    {
        id: "cantidadPorDescargar",
        name: "Por descargar",
        width: 150,
        editable: false,
        resizable: true,
        sortable: false,
        focusable: false,
        dropdown: false,
    },
];

const dataTableOptions = {
    columns: columns.map((item) => ({
        ...dataTableColumnCommonConfiguration,
        ...item,
    })),
    headerDropdown: defaultHeaderDropDown,
    inlineFilters: true,
    serialNoColumn: false,
    checkboxColumn: false,
    noDataMessage: "",
    freezeMessage: freezeGenericMessage,
};

export const dataTableListaMateriales = new DataTable(dataTableListaMaterialesElement, dataTableOptions);

borrarDefaultDropDownOptions(dataTableListaMateriales);
